<template>
  <div></div>
  <CatalogPage class="bayern-catalog-page">
    <!-- <template #card-datasets>
    </template> -->
  </CatalogPage>
</template>

<style lang="scss">
// specified in styles/by/_bayern-catalog-page.scss and imported in styles.scss
</style>

<script>
import CatalogPage from "./catalogues/CatalogPage.vue";

// import { getSubdomainCatalogIdFromUrl } from "../utils/utils";

export default {
  name: "BayernCatalogPage",
  components: {
    CatalogPage,
    // BayernDatasetsPage,
  },
  data() {
    return {
      catalogId:
        this.$route.params?.ctlg_id ||
        getSubdomainCatalogIdFromUrl(window.location.href) ||
        "",
    };
  },
};
</script>
